export const RELANCE_RESET = "RELANCE_RESET";
export const RELANCE_SET_ERROR = "RELANCE_SET_ERROR";
export const RELANCE_SET_ITEMS = "RELANCE_SET_ITEMS";
export const RELANCE_TOGGLE_LOADING = "RELANCE_TOGGLE_LOADING";
